import { CONFIG } from '@/config/config.ts';

const CHUNK_LOAD_ERROR_MESSAGES = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'is not a valid JavaScript MIME type',
  'Unable to preload CSS',
];
const CHUNK_RELOAD_AT_KEY = 'chunkLoadErrorReloadAt';
const CHUNK_RELOAD_COOLDOWN_MS = 30 * 1000;

let isReloading = false;

export const isChunkLoadError = (error: unknown): boolean =>
  error instanceof Error &&
  CHUNK_LOAD_ERROR_MESSAGES.some(message => error.message.includes(message));

export const reloadApp = async (href: string = globalThis.location.href): Promise<void> => {
  isReloading = true;
  try {
    await fetch(href, { cache: 'reload' });
  } catch {}
  if (href === globalThis.location.href) {
    globalThis.location.reload();
    return;
  }
  globalThis.location.assign(href);
};

const wasReloadedAfterChunkErrorRecently = (): boolean => {
  try {
    const reloadedAt = Number(sessionStorage.getItem(CHUNK_RELOAD_AT_KEY));
    return Date.now() - reloadedAt < CHUNK_RELOAD_COOLDOWN_MS;
  } catch {
    return true;
  }
};

export const canReloadAfterChunkLoadError = (): boolean =>
  isReloading || (CONFIG.ENVIRONMENT !== 'local' && !wasReloadedAfterChunkErrorRecently());

export const reloadAfterChunkLoadError = (): boolean => {
  if (isReloading) {
    return true;
  }
  if (!canReloadAfterChunkLoadError()) {
    return false;
  }
  try {
    sessionStorage.setItem(CHUNK_RELOAD_AT_KEY, String(Date.now()));
  } catch {
    return false;
  }
  void reloadApp();
  return true;
};
